import { Stack, Typography } from '@mui/material'
import { type SurveyElement } from '../MidYearSummary'
import { parseSurveyText } from '../../../../../../customComponents/survey/questions/components/parseSurveyText'

export const SummaryHeader = ({ element }: { element: SurveyElement }): JSX.Element => {
  return (
    <Stack direction='row' alignItems='center' gap={1} mt={4}>
      <Typography variant='h4'>{parseSurveyText(element.text)}</Typography>
      {element.description != null && element.description !== '' && (
        <Typography variant='body2' color='text.secondary'>{parseSurveyText(element.description)}</Typography>
      )}
    </Stack>
  )
}
